module.exports = __webpack_public_path__ + "static/media/admin.c8e97da4.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/panel/admin.png
// module id = 801
// module chunks = 23